function updateLinkHref(oldHref, newHref) {
    console.log("Updating link with href: " + oldHref + " to new href: " + newHref);
    var htmlElementToUpdate = document.querySelector("a[href=" + CSS.escape(oldHref) + "]");
    if (htmlElementToUpdate) {
        htmlElementToUpdate.href = newHref
    }
    // code below redirects the user if they try to go to any part of the website 
    if (window.location.pathname.includes(oldHref)) {
        window.location.href = newHref
    }
}
function updateAllMyLinks() {
    const linksToUpdate = [
        { oldHref: '/products/adidas', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/adidas?page=1' },
        { oldHref: '/products/bella-canvas', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/bella_canvas?page=1' },
        { oldHref: '/products/elwood', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/elwood?page=1' },
        { oldHref: '/products/carhartt', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/carhartt?page=1' },
        { oldHref: '/products/columbia', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/columbia?page=1' },
        { oldHref: '/products/comfort-colors', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/comfort_colors?page=1' },
        { oldHref: '/products/dickies', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/dickies?page=1' },
        { oldHref: '/products/lane-seven', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/lane_seven?page=1' },
        { oldHref: '/products/los-angeles-apparel', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/los_angeles_apparel?page=1' },
        { oldHref: '/products/north-face', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/north_face?page=1' },
        { oldHref: '/products/nike', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/nike?page=1' },
        { oldHref: '/products/richardson', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/richardson?page=1' },
        { oldHref: '/products/safety-ansi', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/safety_ansi_hi_vis?page=1' },
        { oldHref: '/products/shaka-wear', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/shakawear?page=1' },
        { oldHref: '/products/weld-mfg', newHref: 'https://design.daileygrace.org/Dailey_Grace/shop/products/brands/weld_mfg?page=1' },
      
      // TODO: Add more links here
    ];
    
    linksToUpdate.forEach(link => {
        updateLinkHref(link.oldHref, link.newHref);
    });
}
updateAllMyLinks();
